// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"605b869b","580":"817f9d6e","784":"3ce78024","796":"bdfaca11","808":"29a16ce5","832":"ac90029e","912":"8c832b40"}[chunkId] + ".chunk.js";
};